// extracted by mini-css-extract-plugin
module.exports = {"marker":"styles_marker__201Vf","root":"styles_root__2YIDS"};